module.exports = __webpack_public_path__ + "img/logo.37102490.png";